import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

const Paragraph = styled(Box)(({ theme }) => ({
  ...theme.typography.body2,
  padding: theme.spacing(1),
  fontSize: "0.9rem",
  textAlign: "left",
  color: theme.palette.text.secondary,
}));
export default Paragraph;
